import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbe31bc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_update_logistics_doc",
  ref: "UpdateLogisticsDocRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_sale_order_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-10" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-7" }
const _hoisted_12 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_13 = { class: "w-100 d-flex el-input el-input-group--prepend el-input--suffix" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__prepend d-flex w-auto flex-center" }, " ≤ ", -1))
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "form-group mb-7" }
const _hoisted_17 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "form-group mb-7" }
const _hoisted_20 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "form-group mb-7" }
const _hoisted_23 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mb-7" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group mb-7" }
const _hoisted_29 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "form-group mb-7" }
const _hoisted_32 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_33 = { class: "d-flex gap-2" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group mb-7" }
const _hoisted_36 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-group mb-7" }
const _hoisted_39 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "form-group mb-7" }
const _hoisted_42 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "form-group mb-7" }
const _hoisted_45 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-group mb-7" }
const _hoisted_48 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = { class: "form-group mb-7" }
const _hoisted_51 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_52 = { class: "col-md-12" }
const _hoisted_53 = { class: "form-group mb-7" }
const _hoisted_54 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_55 = { class: "modal-footer flex-right" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "indicator-label" }
const _hoisted_60 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_61 = { class: "indicator-progress" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("shipmentLabel.edit")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: (_ctx.rules as any),
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("shipmentLabel.shipmentLabelAlarmLimit2")), 1),
                    _createVNode(_component_el_form_item, { prop: "logistics_limit" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_el_input_number, {
                            class: "flex-1",
                            modelValue: _ctx.formData.logistics_limit,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.logistics_limit) = $event)),
                            precision: 0,
                            step: 1,
                            min: 0,
                            controls: false,
                            placeholder: _ctx.t('common.plsEnter')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("shipmentLabel.company")), 1),
                    _createVNode(_component_el_form_item, { prop: "company_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.company_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.company_id) = $event)),
                          filterable: "",
                          clearable: "",
                          "remote-show-suffix": "",
                          remote: "",
                          "remote-method": _ctx.searchMerchantSourceItems,
                          loading: _ctx.options.merchantLoading,
                          placeholder: _ctx.t('common.plsSelect'),
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getAddressData($event, true)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "remote-method", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("shipmentLabel.consigner")), 1),
                    _createVNode(_component_el_form_item, { prop: "sender_address_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.sender_address_id,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.sender_address_id) = $event)),
                          clearable: "",
                          loading: _ctx.options.senderAddressLoading,
                          placeholder: _ctx.t('common.plsSelect'),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getAddressData(_ctx.formData.company_id, true)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.senderAddress, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.key,
                                label: item.value,
                                value: item.key
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("shipmentLabel.finalConsignee")), 1),
                    _createVNode(_component_el_form_item, { prop: "recipient_address_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.recipient_address_id,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.recipient_address_id) = $event)),
                          clearable: "",
                          loading: _ctx.options.recipientAddressLoading,
                          placeholder: _ctx.t('common.plsSelect'),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAddressData(_ctx.formData.company_id, true)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.recipientAddress, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.key,
                                label: item.value,
                                value: item.key
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("shipmentLabel.pickupDate")), 1),
                    _createVNode(_component_el_form_item, { prop: "pick_up_date" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.formData.pick_up_date,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.pick_up_date) = $event)),
                          type: "date",
                          clearable: "",
                          placeholder: _ctx.t('common.pickDate'),
                          style: {"width":"100%"},
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (
                        _ctx.commonChangeDefaultDate(
                          $event,
                          _ctx.formData,
                          'pick_up_date'
                        )
                      ))
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("shipmentLabel.numberOfPackages")), 1),
                    _createVNode(_component_el_form_item, { prop: "package_num" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          class: "w-100",
                          modelValue: _ctx.formData.package_num,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.package_num) = $event)),
                          precision: 0,
                          step: 1,
                          min: 0,
                          controls: false,
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("shipmentLabel.packageSize")), 1),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_el_form_item, { prop: "package_size_l" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            class: "w-100",
                            modelValue: _ctx.formData.package_size_l,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.package_size_l) = $event)),
                            precision: 1,
                            step: 1.0,
                            min: 0.0,
                            controls: false,
                            placeholder: _ctx.t('common.plsEnter')
                          }, null, 8, ["modelValue", "step", "min", "placeholder"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "package_size_w" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            class: "w-100",
                            modelValue: _ctx.formData.package_size_w,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.package_size_w) = $event)),
                            precision: 1,
                            step: 1.0,
                            min: 0.0,
                            controls: false,
                            placeholder: _ctx.t('common.plsEnter')
                          }, null, 8, ["modelValue", "step", "min", "placeholder"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "package_size_h" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            class: "w-100",
                            modelValue: _ctx.formData.package_size_h,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.package_size_h) = $event)),
                            precision: 1,
                            step: 1.0,
                            min: 0.0,
                            controls: false,
                            placeholder: _ctx.t('common.plsEnter')
                          }, null, 8, ["modelValue", "step", "min", "placeholder"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("shipmentLabel.packageWeight")), 1),
                    _createVNode(_component_el_form_item, { prop: "package_weight" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          class: "w-100",
                          modelValue: _ctx.formData.package_weight,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.package_weight) = $event)),
                          precision: 3,
                          step: 1.0,
                          min: 0.0,
                          controls: false,
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "step", "min", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.t("shipmentLabel.packaging2")), 1),
                    _createVNode(_component_el_form_item, { prop: "package_type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.package_type,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.package_type) = $event)),
                          clearable: "",
                          loading: _ctx.options.packageTypeLoading,
                          placeholder: _ctx.t('common.plsSelect')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.packageType, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t("shipmentLabel.contents2")), 1),
                    _createVNode(_component_el_form_item, { prop: "interior_category" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.interior_category,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.interior_category) = $event)),
                          clearable: "",
                          multiple: "",
                          loading: _ctx.options.interiorCategoryLoading,
                          placeholder: _ctx.t('common.plsSelect')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.interiorCategory, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.t("shipmentLabel.valueOfGoods2")), 1),
                    _createVNode(_component_el_form_item, { prop: "package_fee" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          class: "w-100",
                          modelValue: _ctx.formData.package_fee,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.package_fee) = $event)),
                          precision: 2,
                          step: 1.0,
                          min: 0.0,
                          controls: false,
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "step", "min", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.t("shipmentLabel.rate2")), 1),
                    _createVNode(_component_el_form_item, { prop: "service_type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.service_type,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.service_type) = $event)),
                          clearable: "",
                          loading: _ctx.options.serviceTypeLoading,
                          placeholder: _ctx.t('common.plsSelect')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.serviceType, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.t("shipmentLabel.notes")), 1),
                    _createVNode(_component_el_form_item, { prop: "notes" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.notes,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.notes) = $event)),
                          type: "textarea",
                          clearable: "",
                          size: "medium",
                          resize: "none",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("shipmentLabel.sendInformationTo2")), 1),
                    _createVNode(_component_el_form_item, { prop: "email" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "w-100",
                          modelValue: _ctx.formData.email,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.email) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsEnter')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", {
                type: "button",
                class: "btn btn-lg btn-light me-3",
                disabled: _ctx.loading,
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_57, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.cancel")), 1)
              ], 8, _hoisted_56),
              _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    ref: "submitButton",
                    type: "button",
                    class: "btn btn-lg btn-primary",
                    disabled: _ctx.loading,
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                  }, [
                    _createElementVNode("span", _hoisted_59, [
                      _createElementVNode("span", _hoisted_60, [
                        _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.save")), 1)
                    ]),
                    _createElementVNode("span", _hoisted_61, [
                      _hoisted_62,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                    ])
                  ], 8, _hoisted_58)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}